import React, { useEffect, Suspense, lazy } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
// Lazy load non-critical components
const ProblemSolution = lazy(() => import('./components/ProblemSolution'));
const Features = lazy(() => import('./components/Features'));
const RecipeShowcase = lazy(() => import('./components/RecipeShowcase'));
const Testimonials = lazy(() => import('./components/Testimonials'));
const ExpertEndorsement = lazy(() => import('./components/ExpertEndorsement'));
const OfferBonuses = lazy(() => import('./components/OfferBonuses'));
const VisualizateSection = lazy(() => import('./components/VisualizateSection'));
const Guarantee = lazy(() => import('./components/Guarantee'));
const FAQ = lazy(() => import('./components/FAQ'));
const FinalCTA = lazy(() => import('./components/FinalCTA'));
const Footer = lazy(() => import('./components/Footer'));
// Loading fallback
const LoadingFallback = () => <div className="w-full py-8 flex justify-center items-center" data-id="element-0">
    <div className="w-8 h-8 border-4 border-custom-brown border-t-transparent rounded-full animate-spin" data-id="element-1"></div>
  </div>;
export function App() {
  // Simplified Meta Pixel tracking - just use what's already initialized in HTML
  useEffect(() => {
    if (window.fbq) {
      // Send a PageView event when the app mounts
      window.fbq('track', 'PageView');
      window.fbq('track', 'ViewContent', {
        content_name: '7 Cenas Latinas en 30 Minutos',
        content_type: 'product'
      });
    }
  }, []);
  return <div className="w-full min-h-screen bg-white font-sans" data-id="element-2">
      <Header data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <Suspense fallback={<LoadingFallback data-id="element-7" />} data-id="element-6">
          <ProblemSolution data-id="element-8" />
          <Features data-id="element-9" />
          <RecipeShowcase data-id="element-10" />
          <Testimonials data-id="element-11" />
          <ExpertEndorsement data-id="element-12" />
          <OfferBonuses data-id="element-13" />
          <VisualizateSection data-id="element-14" />
          <Guarantee data-id="element-15" />
          <FAQ data-id="element-16" />
          <FinalCTA data-id="element-17" />
        </Suspense>
      </main>
      <Suspense fallback={<LoadingFallback data-id="element-19" />} data-id="element-18">
        <Footer data-id="element-20" />
      </Suspense>
    </div>;
}